import React from 'react';

const TypingContext = React.createContext({
  typing: false,
  message: null
});

export default TypingContext;
